import produce from 'immer';
import Queue from 'helpers/queue';

export const baseCreative = () => ({
  isGettingList: false,
  isGettingCreativeById: false,
  isCreating: false,
  isUpdating: false,
  isDeleting: false,
  isFiltering: false,
  isLast: false,

  listCreative: [],
  creative: {},

  errorGettingCreativeById: null,
  errorGettingList: null,
  errorCreating: null,
  errorDeleting: null,
  errorUpdating: null,
  errorFiltering: null,
  errorUpdatingCreative: null,

  queueUpdatingCreative: [],
});

//* Update creative campaign
const queueUpdatingCreative = new Queue();

export const fetchUpdateCreativeCampaign = (actions, state) => {
  queueUpdatingCreative.pushToQueue(actions.id);

  return produce(state, (draft) => {
    draft.queueUpdatingCreative = queueUpdatingCreative.queue;
  });
};

export const fetchUpdateCreativeCampaignSuccess = (actions, state) => {
  queueUpdatingCreative.removeFromQueue(actions.id);

  return produce(state, (draft) => {
    draft.queueUpdatingCreative = queueUpdatingCreative.queue;
    draft.errorUpdatingCreative = null;
  });
};

export const fetchUpdateCreativeCampaignFailed = (actions, state) => {
  queueUpdatingCreative.removeFromQueue(actions.id);

  return produce(state, (draft) => {
    draft.queueUpdatingCreative = queueUpdatingCreative.queue;
    draft.errorUpdatingCreative = actions.error;
  });
};

//* Filter creative
export const fetchFilterCreative = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFiltering = true;
  });
};

export const fetchFilterCreativeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFiltering = false;
    draft.listCreative = actions.listCreative;
    draft.isLast = actions.isLast;
  });
};

export const fetchFilterCreativeFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isFiltering = false;
    draft.errorFiltering = actions.error;
  });
};

//* Update creative
export const fetchUpdateCreative = (actions, state) => {
  return produce(state, (draft) => {
    draft.isUpdating = true;
  });
};

export const fetchUpdateCreativeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isUpdating = false;
    draft.listCreative = actions.listCreative;
    draft.creative = actions.creative;
    draft.errorUpdating = null;
  });
};

export const fetchUpdateCreativeFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isUpdating = false;
    draft.errorUpdating = actions.error;
  });
};

//* Get creative by ID
export const fetchCreativeByID = (actions, state) => {
  return produce(state, (draft) => {
    draft.isGettingCreativeById = true;
  });
};

export const fetchCreativeByIDSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.creative = actions.creative;
    draft.isGettingCreativeById = false;
    draft.errorGettingCreativeById = null;
  });
};

export const fetchCreativeByIDFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorGettingCreativeById = actions.error;
    draft.isGettingCreativeById = false;
  });
};

//* Delete creative
export const fetchDeleteCreative = (actions, state) => {
  return produce(state, (draft) => {
    draft.isDeleting = true;
  });
};

export const fetchDeleteCreativeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isDeleting = false;
    draft.errorDeleting = null;
  });
};

export const fetchDeleteCreativeFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorDeleting = actions.error;
    draft.isDeleting = false;
  });
};

//* Create creative
export const fetchCreateCreative = (actions, state) => {
  return produce(state, (draft) => {
    draft.isCreating = true;
  });
};

export const fetchCreateCreativeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isCreating = false;
  });
};

export const fetchCreateCreativeFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.isCreating = false;
    draft.errorCreating = actions.error;
  });
};

//* Get list creative
export const fetchListCreative = (actions, state) => {
  return produce(state, (draft) => {
    draft.isGettingList = true;
  });
};

export const fetchListCreativeSuccess = (actions, state) => {
  return produce(state, (draft) => {
    draft.isGettingList = false;
    draft.isGotList = true;
    draft.isLast = actions.isLast;
    draft.listCreative = actions.data;
    draft.errorGettingList = null;
  });
};

export const fetchListCreativeFailed = (actions, state) => {
  return produce(state, (draft) => {
    draft.errorGettingList = actions.error;
    draft.isGettingList = false;
  });
};
